module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "perfectInformation"
  }, [_c('div', {
    staticClass: "backdrop",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.dismiss($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    ref: "dialogContent",
    staticClass: "dialogContent"
  }, [_c('h2', {
    attrs: {
      "title": _vm.title
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('span', {
    staticClass: "close",
    on: {
      "click": _vm.dismiss
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/order-close.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', [_vm._v("需要获取您的手机通讯录")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("请您通过"), _c('span', {
    staticStyle: {
      "color": "#0068b7"
    }
  }, [_vm._v("融资专家APP")]), _vm._v("提交您的手机通讯录信息")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-group"
  }, [_c('div', {
    staticClass: "item"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/rzzj_downloaded.png",
      "alt": "融资专家APP"
    }
  }), _vm._v(" "), _c('span', [_vm._v("APP下载")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-19120e20"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/perfectInformation.vue
// module id = 586
// module chunks = 1